import { render, staticRenderFns } from "./prebuiltTemplatesNavBar.vue?vue&type=template&id=f23f0a6c&scoped=true&"
import script from "./prebuiltTemplatesNavBar.vue?vue&type=script&lang=js&"
export * from "./prebuiltTemplatesNavBar.vue?vue&type=script&lang=js&"
import style0 from "./prebuiltTemplatesNavBar.vue?vue&type=style&index=0&id=f23f0a6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23f0a6c",
  null
  
)

export default component.exports